import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const API_PREFIX = `${BASE_URL}/admin/curl-request-response-logs`;

export const listCurlRequestResponseLogs = (params) =>
  axios.get(`${API_PREFIX}`, {
    params,
    headers: getAuthHeaders(),
  });

export const getCurlRequestResponseLogsFilterOptions = () =>
  axios.get(`${API_PREFIX}/filter-options`, {
    headers: getAuthHeaders(),
  });

export const getCurlRequestResponseLogDetail = (logUid) =>
  axios.get(`${API_PREFIX}/${encodeURIComponent(logUid)}`, {
    headers: getAuthHeaders(),
  });

